import { useParams, Link } from 'react-router-dom';
import { categories, articleList } from '@/mocks/articles';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];
  const filteredArticles = articleList.filter((a) => a.category === currentCategory.id);

  const articleCovers: Record<number, string> = {
    1: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20dramatic%20lighting%20and%20warm%20tones%2C%20movie%20set%20atmosphere%20with%20vintage%20camera%20equipment%2C%20soft%20bokeh%20background%2C%20editorial%20photography%20style%2C%20rich%20colors%20and%20deep%20shadows%2C%20artistic%20composition&width=640&height=360&seq=article-cover-01&orientation=landscape',
    2: 'https://readdy.ai/api/search-image?query=Professional%20video%20production%20studio%20interior%20with%20modern%20equipment%2C%20cameras%20and%20lighting%20rigs%2C%20warm%20ambient%20lighting%2C%20clean%20organized%20workspace%2C%20cinematic%20production%20atmosphere%2C%20high-end%20professional%20photography&width=640&height=360&seq=article-cover-02&orientation=landscape',
    3: 'https://readdy.ai/api/search-image?query=Premium%20lifestyle%20scene%20with%20golden%20warm%20tones%2C%20elegant%20interior%20setting%20with%20comfortable%20sofa%20and%20tablet%20device%2C%20cozy%20atmosphere%20with%20soft%20lighting%2C%20modern%20minimal%20design%2C%20luxurious%20yet%20accessible%20feeling&width=640&height=360&seq=article-cover-03&orientation=landscape',
    4: 'https://readdy.ai/api/search-image?query=Person%20holding%20smartphone%20filming%20outdoor%20scene%20with%20beautiful%20natural%20lighting%2C%20golden%20hour%20photography%2C%20urban%20background%20with%20warm%20sunset%20tones%2C%20creative%20mobile%20filmmaking%2C%20casual%20lifestyle%20photography&width=640&height=360&seq=article-cover-04&orientation=landscape',
    5: 'https://readdy.ai/api/search-image?query=Intimate%20live%20music%20performance%20scene%20with%20warm%20stage%20lighting%2C%20acoustic%20guitar%20player%20on%20small%20stage%2C%20atmospheric%20venue%20with%20soft%20amber%20spotlights%2C%20indie%20music%20concert%20photography%2C%20artistic%20moody%20atmosphere&width=640&height=360&seq=article-cover-05&orientation=landscape',
    6: 'https://readdy.ai/api/search-image?query=Street%20food%20scene%20in%20Asian%20night%20market%20with%20steam%20rising%20from%20food%20stalls%2C%20warm%20tungsten%20lighting%2C%20colorful%20food%20displays%2C%20bustling%20atmosphere%2C%20food%20photography%20with%20shallow%20depth%20of%20field%2C%20authentic%20cultural%20experience&width=640&height=360&seq=article-cover-06&orientation=landscape',
    7: 'https://readdy.ai/api/search-image?query=Modern%20tech%20gadgets%20arranged%20on%20clean%20minimalist%20desk%2C%20smartphone%20smartwatch%20wireless%20earbuds%2C%20natural%20light%20from%20window%2C%20product%20photography%20with%20neutral%20background%2C%20sleek%20contemporary%20design%20aesthetic&width=640&height=360&seq=article-cover-07&orientation=landscape',
    8: 'https://readdy.ai/api/search-image?query=Elderly%20artisan%20working%20with%20traditional%20craft%20tools%20in%20rustic%20workshop%2C%20warm%20natural%20light%20through%20window%2C%20wooden%20textures%20and%20hand%20tools%2C%20documentary%20photography%20style%2C%20authentic%20cultural%20heritage%20atmosphere&width=640&height=360&seq=article-cover-08&orientation=landscape',
  };

  return (
    <main className="min-h-screen pt-20 pb-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '分类浏览', path: '/category/drama' },
              { label: currentCategory.name },
            ]}
          />
        </div>

        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center">
              <i className={`${currentCategory.icon} text-primary-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
            </div>
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              {currentCategory.name}
            </h1>
          </div>
          <p className="text-sm text-foreground-600 ml-13 pl-13">{currentCategory.description}</p>
        </div>

        <div className="flex gap-2 flex-wrap mb-10 pb-4 border-b border-background-200/70">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                cat.slug === slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        {filteredArticles.length === 0 ? (
          <div className="text-center py-20">
            <div className="w-16 h-16 rounded-full bg-background-100 flex items-center justify-center mx-auto mb-4">
              <i className="ri-inbox-line text-foreground-400 text-2xl w-8 h-8 flex items-center justify-center"></i>
            </div>
            <p className="text-foreground-500 text-sm">该分类暂无内容，敬请期待</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {filteredArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group cursor-pointer bg-background-100/50 rounded-xl overflow-hidden hover:bg-background-100 transition-all duration-200 border border-background-200/60"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={articleCovers[article.id]}
                    alt={article.title}
                    title={`${article.title} - 麻豆视频`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  />
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-primary-600 font-medium">{currentCategory.name}</span>
                    <span className="text-xs text-foreground-400">{article.publishDate}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i></span>
                      {(article.views / 10000).toFixed(1)}万
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-time-line w-3 h-3 flex items-center justify-center"></i></span>
                      {article.readTime}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}